












import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import EnabledFeaturesForm from '@superUI/Forms/EnabledFeaturesForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "EnabledFeaturesCreate"
  components: { Back, SuperContainerView, EnabledFeaturesForm, RequestButton }
  resources:
    newEnabledFeature:
      resourceName: "enabled_feature"
      slug: "/marketplace/settings/enabled_features"
  vue:
    methods:
      hiSave: ->
        await @save("marketplace/settings/enabled_features/#{@newEnabledFeature.name}", "enabled_features", {})
        @$router.push({ name: 'EnabledFeaturesListPage' })

export default VueOptions.vue settings
